import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CompanyStatusEnum, LeaveRequestStatusEnum } from '../../../api/v1';
import {
  ChipDisplayTypes,
  ChipStatusColours,
  ChipStatuses,
  ChipVariantTypes,
  StyleClassType,
} from '../../lib/chip/chip';


export default /*#__PURE__*/_defineComponent({
  __name: 'Chip',
  props: {
    text: { default: '' },
    icon: { default: null },
    prependIcon: { default: null },
    iconPosition: { default: 'right' },
    clickable: { type: Boolean, default: false },
    hoverEffect: { default: 'darken' },
    status: { default: null },
    variant: { default: 'flat' },
    display: { default: 'inline-block' },
    dataTestid: { default: '' }
  },
  setup(__props: any) {

const props = __props as { text: string, icon: string | null, prependIcon: string | null, iconPosition: string, clickable: boolean, hoverEffect: string, status: ChipStatusColours | null, variant: ChipVariantTypes, display: ChipDisplayTypes, dataTestid: string }

const styleClasses: StyleClassType = {
  success: {
    tonal: 'border-green-100 text-green-900 bg-green-100',
    outline: 'border-green-900 text-green-900 bg-white',
    flat: 'border-green-900 text-white bg-green-900',
  },
  error: {
    tonal: 'border-red-50 text-red-800 bg-red-50',
    outline: 'border-red-800 text-red-800 bg-white',
    flat: 'border-red-800 text-white bg-red-800',
  },
  info: {
    tonal: 'border-blue-50 text-blue-900 bg-blue-50',
    outline: 'border-blue-900 text-blue-900 bg-white',
    flat: 'border-blue-900 text-white bg-blue-900',
  },
  warning: {
    tonal: 'border-yellow-50 text-yellow-900 bg-yellow-50',
    outline: 'border-yellow-900 text-yellow-900 bg-white',
    flat: 'border-yellow-900 text-white bg-yellow-900',
  },
  pink: {
    tonal: 'border-pink-50 text-pink-700 bg-pink-50',
    outline: 'border-pink-700 text-pink-700 bg-white',
    flat: 'border-pink-700 text-white bg-pink-700',
  },
  purple: {
    tonal: 'border-purple-50 text-purple-700 bg-purple-50',
    outline: 'border-purple-700 text-purple-700 bg-white',
    flat: 'border-purple-700 text-white bg-purple-700',
  },
  gray: {
    tonal: 'border-purple-50 text-gray-700 bg-purple-50',
    outline: 'border-gray-700 text-gray-700 bg-white',
    flat: 'border-gray-700 text-white bg-gray-700',
  },
  gray500: {
    tonal: 'border-purple-50 text-gray-500 bg-purple-50',
    outline: 'border-gray-500 text-gray-500 bg-white',
    flat: 'border-gray-500 text-white bg-gray-500',
  },
};

const warningStatuses = {
  Pending: styleClasses.warning,
  unpublished: styleClasses.warning,
  yellow: styleClasses.warning,
  [CompanyStatusEnum.Locked]: styleClasses.warning,
  [LeaveRequestStatusEnum.PendingApproval]: styleClasses.warning,
};

const successStatuses = {
  Complete: styleClasses.success,
  Paid: styleClasses.success,
  published: styleClasses.success,
  assigned: styleClasses.success,
  Approved: styleClasses.success,
  green: styleClasses.success,
  Started: styleClasses.success,
  [LeaveRequestStatusEnum.PendingCancellation]: styleClasses.success,
  [CompanyStatusEnum.Active]: styleClasses.success,
};

const errorStatuses = {
  Denied: styleClasses.error,
  Failed: styleClasses.error,
  red: styleClasses.error,
  Missing: styleClasses.error,
  [CompanyStatusEnum.Closed]: styleClasses.error,
  [CompanyStatusEnum.Suspended]: styleClasses.error,
};

const otherColorStatuses = {
  blue: styleClasses.info,
  pink: styleClasses.pink,
  gray: styleClasses.gray,
  gray500: styleClasses.gray500,
  purple: styleClasses.purple,
};

const statusStyleMap = {
  ...warningStatuses,
  ...successStatuses,
  ...errorStatuses,
  ...otherColorStatuses,
  [ChipStatuses.info]: styleClasses.info,
};



const chipStyling = computed(() => {
  if (props.status) {
    const statusClasses = statusStyleMap[props.status];
    if (statusClasses) {
      const variantClass = statusClasses[props.variant];
      if (variantClass) return variantClass;
      return statusClasses.flat;
    }
  }
  return styleClasses.purple.flat;
});

return { __sfc: true,styleClasses, warningStatuses, successStatuses, errorStatuses, otherColorStatuses, statusStyleMap, props, chipStyling }
}

})